import { createGlobalStyle } from 'styled-components';
import { layout } from '../../package.json';
import { config } from '../config';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  html {
    min-height: 100%;
  }

  body {
    font-family: 'Roboto', sans-serif;
    @media (max-width: ${layout.desktop_wide}) {
      font-size: 93.75%; // 15px;
    }
    @media (max-width: ${layout.tablet}) {
      font-size: 87.5%; //14 px
    }
  }

  h1,h2,h3,h4,h5,h6,strong {
    font-weight: 500;
  }

  button, input {
    border: 0;
    background: none;
    color: var(--primary);
    transition: color .2s ease-out;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  :root {
    --white: #fff;
    --black: #1b1f23;
    --gray: #586069;
    --gray-light: #ccc;
    --gray-dark: #24292e;
    --primary: ${config.color.primary};
    --primary_dark: ${config.color.primary_dark};
    --primary_light: ${config.color.primary_light};
    --logo: #fff;
    --header: #24292e;
    --username: #666;
    --search: rgba(255, 255, 255, 0.13);
    --search-placeholder: hsla(0;0%;100%;.75);
    --icon: #6a737d;
    --link: #0366d6;
    --border: #e1e4e8;

    --green: #39e600;
    --fontcolor: #646464;
    --star-on: #f8da48;
    --star-off: #e2e2e2;

    --navbar: ${config.color.navbar.bg};
    --navbarcolor: ${config.color.navbar.color};
    --navbarhover: ${config.color.navbar.hover};

    --menucolor: #ffffff;

    --btn-canc: #ff0000;
    --btn-finish: #00b300;

    --select-on:  #ccffcc;
    --select-b-on: #00b300;

    --cardbg: #fff;
    --cardborder: ${config.color.primary};
    --cardselbg: #ccffcc;
    --cardselborder: #00b300;
    --cardhoverbg: #ccc;
    --cardhoverborder: #666
  }

  /* ===== Scrollbar Global ===== */
  /* Remove setas padrão */
  *::-webkit-scrollbar-button {
    display: none;
  }

  /* Barra do scroll */
  *::-webkit-scrollbar {
    width: 15px;
    height: 8px;
  }

  /* Track (fundo da barra) */
  *::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 4px;
  }

  /* Thumb (barra que você arrasta) */
  *::-webkit-scrollbar-thumb {
    background-color: var(--primary);
    border-radius: 30px;
    border: 1px solid #fff;
  }

  /* Hover do thumb */
  *::-webkit-scrollbar-thumb:hover {
    background-color: var(--primary_light);
  }
`;
